/* eslint-disable no-console */
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from '@material-ui/core';
import {
  fetchUserActivityTimeout,
  setIsIdle,
} from '@src/reducers/userActivity';
import { userLogged } from '@src/selectors/user';
import type { RootState } from '@src/store/reduxstore';
import { useEffect, useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

// TODO: remove debugs when finished

const CHECK_EVERY = 1 * 60 * 1000; // 1 minute
const DEBOUNCE = 1 * 60 * 1000; // 1 minute
const TIME_BEFORE_LOGOUT = 2 * 60 * 1000; // 2 minutes

const UserActivity = () => {
  const dispatch = useDispatch();
  const [lastActiveTime, setLastActiveTime] = useState(Date.now());

  const isLogged = useSelector(userLogged);

  const timeout = useSelector(
    (state: RootState) => state.adminHome.userActivity.timeout
  );
  console.log('timeout: ', timeout);

  const isIdle = useSelector(
    (state: RootState) => state.adminHome.userActivity.isIdle
  );

  console.log('isIdle: ', isIdle);
  const { getLastActiveTime } = useIdleTimer({
    events: [
      'mousemove',
      'keydown',
      'wheel',
      'DOMMouseScroll',
      'mousewheel',
      'mousedown',
      'visibilitychange',
    ],
    debounce: DEBOUNCE,
  });

  useEffect(() => {
    const checkIsIdle = () => {
      if (timeout <= 0) return;
      const elapsedTime = Date.now() - lastActiveTime;
      console.log('checking: ');
      console.log('lastActiveTime: ', lastActiveTime);
      console.log('timeout: ', timeout);
      console.log('TIME_BEFORE_LOGOUT: ', TIME_BEFORE_LOGOUT);

      if (isIdle && elapsedTime > timeout) {
        window.location.href = '/logout';
      }

      // react-idle-timer v5 returns Date | null (v4 returned a timestamp)
      setLastActiveTime(getLastActiveTime()?.getTime() ?? Date.now());
      console.log('timeout - elapsedTime: ', timeout - elapsedTime);

      if (timeout - elapsedTime <= TIME_BEFORE_LOGOUT) {
        dispatch(setIsIdle(true));
      }
    };
    checkIsIdle();
    const interval = setInterval(() => {
      checkIsIdle();
    }, CHECK_EVERY);

    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timeout, lastActiveTime]);

  useEffect(() => {
    if (isLogged && timeout === 0) dispatch(fetchUserActivityTimeout());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLogged]);

  return (
    <Dialog open={isIdle} closeAfterTransition disableEscapeKeyDown>
      <DialogTitle>
        <Box display="flex" flexDirection="column" alignItems="left">
          <svg
            width="139"
            height="36"
            viewBox="0 0 139 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18.2329 14.5415C19.0649 13.8466 19.7274 12.9761 20.1712 11.9946C20.615 11.013 20.8288 9.94566 20.7966 8.87165C20.8334 7.74215 20.6132 6.61885 20.1518 5.58413C19.6905 4.54941 18.9999 3.62953 18.1307 2.89195C16.3481 1.36346 14.1422 0.597923 11.513 0.595341H0.809977C0.59547 0.596359 0.390043 0.68074 0.238361 0.830138C0.0866799 0.979536 0.00103379 1.18187 0 1.39315V29.5605V34.2079C0.00101199 34.571 0.113651 34.9253 0.323127 35.2241C0.532603 35.5229 0.829086 35.7522 1.17347 35.8817C1.51786 36.0113 1.89397 36.035 2.25234 35.9499C2.6107 35.8647 2.9345 35.6746 3.18101 35.4046L8.49322 29.5721H12.3545C15.0387 29.5721 17.2931 28.7859 19.1176 27.2135C20.0079 26.4585 20.7152 25.5166 21.1874 24.457C21.6596 23.3974 21.8848 22.2471 21.8464 21.0905C21.8961 19.78 21.5869 18.4804 20.9511 17.3282C20.3153 16.1759 19.3764 15.2134 18.2329 14.5415ZM6.72379 6.79579H11.513C11.8553 6.783 12.1965 6.84081 12.5148 6.96553C12.833 7.09025 13.1213 7.27912 13.3611 7.52002C13.822 8.02598 14.0769 8.6818 14.0769 9.36157C14.0769 10.0413 13.822 10.6972 13.3611 11.2031C13.1213 11.444 12.833 11.6329 12.5148 11.7576C12.1965 11.8823 11.8553 11.9401 11.513 11.9273H6.72379V6.79579ZM14.3677 22.5816C14.1052 22.8414 13.7906 23.0445 13.4439 23.1778C13.0973 23.3112 12.7263 23.3719 12.3545 23.3562H6.72379V17.7947H12.3545C12.7263 17.779 13.0973 17.8397 13.4439 17.9731C13.7906 18.1064 14.1052 18.3095 14.3677 18.5693C14.8569 19.1266 15.1261 19.8387 15.1261 20.5754C15.1261 21.3122 14.8569 22.0243 14.3677 22.5816ZM24.131 29.5527V24.7465L34.0043 14.65C35.994 12.6361 36.9888 10.9256 36.9888 9.51842C37.0146 9.10667 36.9507 8.69424 36.8012 8.30887C36.6517 7.92351 36.4202 7.57414 36.1221 7.28427C35.8241 6.99441 35.4665 6.77077 35.0734 6.62839C34.6803 6.48601 34.2608 6.42821 33.8431 6.45886C31.885 6.45886 30.4432 7.50711 29.5179 9.60362L23.8478 6.33105C24.6441 4.37535 26.0569 2.72317 27.8782 1.61778C29.6515 0.545178 31.6954 -0.0144648 33.7763 0.00279329C36.357 -0.0566872 38.8672 0.835596 40.8146 2.50466C42.7597 4.17516 43.7322 6.41625 43.7322 9.22795C43.7322 12.2849 42.2066 15.3187 39.1553 18.3292L34.2678 23.1741H44.1529V29.545L24.131 29.5527Z"
              fill="#4C33FF"
            />
            <path
              d="M62.8507 29.4534C58.3744 29.4534 54.6881 28.0333 51.7917 25.1932C48.8953 22.3531 47.4391 18.865 47.4233 14.7289C47.4233 10.5902 48.8795 7.10084 51.7917 4.26074C54.7039 1.42064 58.3902 0.000585267 62.8507 0.000585267C65.462 -0.0222315 68.0327 0.622464 70.2997 1.86867C72.504 3.05688 74.3338 4.79497 75.5962 6.8996L72.1797 8.79807C71.3266 7.22052 70.0129 5.91674 68.3999 5.04671C66.7201 4.11292 64.8107 3.6291 62.8704 3.64564C59.4658 3.64564 56.6879 4.69992 54.5367 6.80848C52.3854 8.91704 51.3098 11.5546 51.3098 14.7213C51.3098 17.8575 52.3854 20.4812 54.5367 22.5923C56.6879 24.7034 59.4658 25.7577 62.8704 25.7552C64.8107 25.7717 66.7201 25.2879 68.3999 24.3541C70.0044 23.4923 71.3167 22.2044 72.1797 20.6445L75.5962 22.5088C74.3508 24.6243 72.5257 26.371 70.3195 27.5587C68.0499 28.8186 65.4714 29.4728 62.8507 29.4534ZM89.4357 8.11462C91.9108 8.11462 93.8949 8.86515 95.3879 10.3662C96.8808 11.8673 97.626 13.9024 97.6233 16.4717V28.9256H93.9541V16.6767C93.9541 15.0238 93.4894 13.7455 92.5599 12.8418C91.6304 11.9381 90.3507 11.485 88.7209 11.4825C87.9043 11.4489 87.0893 11.5776 86.3269 11.8605C85.5644 12.1434 84.8708 12.5744 84.2894 13.1266C83.1624 14.2201 82.6002 15.9034 82.6029 18.1765V28.9256H78.9297V0.547344H82.6029V11.5584C84.0932 9.26509 86.3708 8.11715 89.4357 8.11462ZM119.117 8.6424H122.79V28.9256H119.117V25.4362C117.29 28.1168 114.632 29.4559 111.143 29.4534C109.73 29.4746 108.328 29.2109 107.027 28.6792C105.726 28.1475 104.556 27.3596 103.591 26.3665C101.585 24.3198 100.467 21.6136 100.467 18.8011C100.467 15.9886 101.585 13.2824 103.591 11.2357C104.554 10.2392 105.724 9.448 107.025 8.91302C108.325 8.37804 109.728 8.11123 111.143 8.12981C114.629 8.12981 117.287 9.46886 119.117 12.147V8.6424ZM111.613 26.0475C112.608 26.0715 113.597 25.8981 114.519 25.5381C115.442 25.1781 116.277 24.6394 116.973 23.9554C118.352 22.5602 119.121 20.7089 119.121 18.784C119.121 16.8591 118.352 15.0078 116.973 13.6126C115.545 12.2784 113.632 11.5321 111.641 11.5321C109.649 11.5321 107.737 12.2784 106.309 13.6126C104.929 15.0078 104.16 16.8591 104.16 18.784C104.16 20.7089 104.929 22.5602 106.309 23.9554C106.996 24.6347 107.821 25.1709 108.733 25.5308C109.645 25.8907 110.624 26.0666 111.609 26.0475H111.613ZM139 12.052H133.387V23.0441C133.387 24.0465 133.589 24.7565 134 25.1742C134.25 25.3994 134.545 25.5732 134.868 25.6848C135.191 25.7965 135.533 25.8437 135.876 25.8235C136.721 25.8235 137.76 25.8235 139 25.7627V28.9256C135.793 29.3331 133.443 29.08 131.95 28.1662C130.457 27.2524 129.712 25.5413 129.714 23.0328V12.052H125.535V8.6348H129.714V4.01774L133.387 2.96219V8.65758H139V12.052Z"
              fill="#323444"
            />
          </svg>
          <Box mt={4}>
            <FormattedMessage id="AutomaticLogout.Dialog.title" />
          </Box>
        </Box>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Typography style={{ fontSize: 12, lineHeight: '19.6px' }}>
            <FormattedMessage
              id="AutomaticLogout.Dialog.content"
              values={{
                b: str => <b>{str}</b>,
              }}
            />
          </Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Box display="flex" justifyContent="space-between" width="100%">
          <Button
            onClick={() => {
              dispatch(setIsIdle(false));
              setTimeout(() => {
                window.location.href = '/logout';
              }, 500);
            }}
            color="primary"
            variant="outlined"
          >
            <FormattedMessage id="AutomaticLogout.Dialog.action.close" />
          </Button>
          <Button
            onClick={() => {
              dispatch(setIsIdle(false));
              setLastActiveTime(Date.now());
            }}
            color="primary"
            variant="contained"
          >
            <FormattedMessage id="AutomaticLogout.Dialog.action.keep" />
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default UserActivity;
